import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Grid} from '@mui/material'

import ChoiceButton from '@progyny/components/Buttons/ChoiceButton'
import MobileStickyActions, {
  MOBILE_STICKY_HEIGHT,
} from '@progyny/components/MobileStickyActions'
import {FamilyFormingJourneys, UNSET} from '@progyny/const/index'
import {useResponsive} from '@progyny/hooks/useResponsive'
import {SetupProfileSubProps} from '@progyny/pages/SetUpProfile/types'
import {useMeStore} from '@progyny/store/meStore'

const FamilyFormingJourney: React.FC<SetupProfileSubProps> = (props) => {
  const {
    onboardingData,
    navigator: Navigator,
    persistMemberData,
    callback,
  } = props
  const {t} = useTranslation()
  const isMobile = useResponsive('down', 'md')
  const handleChoiceClick = async (choice: string) => {
    await persistMemberData({familyFormingJourney: choice}, callback)
  }
  const isInConservativeCountry = useMeStore((s) => s.isInConservativeCountry)

  const checkChoice = (item: any) =>
    item.value !== UNSET &&
    (!isInConservativeCountry() ||
      !['surrogacy', 'adopt-or-foster'].includes(item.value))

  return (
    <>
      <Grid
        container
        justifyContent={'center'}
        sx={{pb: {xs: MOBILE_STICKY_HEIGHT, md: 0}}}
      >
        <Grid item xs={12}>
          <Box mt={3}>
            {FamilyFormingJourneys.filter(checkChoice).map((item) => (
              <ChoiceButton
                data-role={'choice'}
                key={item.value}
                isSelected={onboardingData.familyFormingJourney === item.value}
                onClick={() => handleChoiceClick(item.value)}
                size={'large'}
              >
                {t(item.label!)}
              </ChoiceButton>
            ))}
          </Box>
        </Grid>
      </Grid>
      <MobileStickyActions>
        <Navigator
          submitDataRole={'complete-profile'}
          backButtonType='outlined'
          singleCentered
          fullWidth={isMobile}
        />
      </MobileStickyActions>
    </>
  )
}

export default FamilyFormingJourney
